module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 83300.f5a9bdf0.png";